import './owners.css'

export default function Owners(){

    return (
        <div className="main-owners">
            <h1>Where Leadership Commands Excellence</h1>
            <div className="messages">
                <div className='owner'>
                    <div className='msg'>
                        <div className='owner-message'>
                        <p>We don't follow trends - we set them. At Sarte Groups, we lead with vision, deliver with purpose, and grow through relentless commitment
                            to excellence. When you work with us, you work with the future.
                        </p>
                        </div>
                        <div className='owner-heading'>
                            <h2>Hamdan Nasir Jamali</h2>
                            <div className='owner-subheading'>
                                <h3>Co-Founder</h3>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='owner second'>
                   <div className='msg'>
                    <div className='owner-message'>
                        <p>Excellence isn't a goal - it's our standard. Sarte Groups is built to raise the bar in every industry we enter.
                            With us, you don't just get results - you get a legacy.
                        </p>
                    </div>
                        <div className='owner-heading'>
                            <h2>Muhammad Kohmir Gola</h2>
                            <div className='owner-subheading'>
                                <h3>Co-Founder</h3>

                            </div>
                            
                        </div>
                   </div>

                </div>
            </div>
        </div>
    )
}